module.exports = __webpack_public_path__ + "img/property.e866ca8c.svg";